import O from "./O";
import MicroscopySupplementTable from './MicroscopySupplementTable';
import SupplementTableCell from './SupplementTableCell';

import SupplementReportImageEnhancements from "./SupplementReportImageEnhancements";
import useReport from './useReport';

import headers from './SupplementTableSpec';





const defaultErrorDiv = (
  <div class="absolute-cover" style={{
    background:'white',
    border:'3px solid red',
    zIndex:-1,
  }}/>
)




export const getReportDisplayOrder = () => ([
  { label:'', colspan:["target"] },
  { label:'Reps', colspan:["enoughReplicates","replId"] },
  { label:'Image', colspan:["replicates.imageEnhancements"] },
  { label:'Loading Control', colspan:["replicates.lcPres","replicates.lcLinRange","replicates.lcUniformDist"] },
  { label:'MW', colspan:["replicates.mwMatch"] },
])


const superheader = getReportDisplayOrder();
const columnOrder = superheader.map(x => x.colspan).flat();


const flat = ["target"];


const tasks = {
  focusComplete:[ "replicates.lcUniformDist","replicates.imageEnhancements", "replicates.mwExp", "replicates.lcLinRange", "replId" ],
  messageComplete:[],
}


export default function SupplementTable({selectedItem,setSelectedItem}){

  const report = useReport();


  





  

  let selectedReportItem;



  let componentMap = {
    imageEnhancements:<SupplementReportImageEnhancements focus={selectedReportItem}/> 
  }

  



  return (
    <div class="sg-row">

      <div>
        <table style={{overflow:'hidden', border:'1px solid #ccc'}}>


          <tr>
            {superheader.map(({label,colspan}) => (
              <td style={{
                border:'1px solid #ccc',
                textAlign:'center',
                fontWeight:'bold',
                background:'white',
              }} colSpan={colspan.length}>{label}</td>
            ))}
          </tr>



          <tr style={{border:'1px solid #ccc'}}>
            {columnOrder.map((key,ii) => {

              let info = headers[key];

              if( !info ){
                debugger;
              }

              let { header } = info;




              return flat.includes(key) ? <td style={{fontWeight:'bold', width:50, textAlign:'center'}}>{header}</td> : <td class="rel" style={{
                //overflow:'visible',
                whiteSpace:'nowrap',
                textAlign:'center',
                border:'1px solid #ccc',
                borderBottom:'1px solid #ccc',
              }}>
                <div style={{margin:5}}>
                  {header}
                </div>
              </td>
            })}
          </tr>



          {Object.entries(report).map(([fpId,fpList]) => {
            return fpList.map((targetObject,targetIndex) => (
              <tbody style={{
                borderBottom:'1px solid #aaa',
              }}>{targetObject.replicates.map((listItemRep,replicateIndex) => (
                <tr class="report-table-row-hoverable" style={{
                  //borderTop:'1px solid #ccc',
                  borderTop:(replicateIndex!==0 && '1px solid #ccc'),
                }}>
                  {columnOrder.map(key => {


                    let reportConfig = headers[key];
                    let { ignoreSelection } = reportConfig;



                    let rowSpan = 1;
                    if( ["target","enoughReplicates"].includes(key) ){
                      if( replicateIndex > 0 ){
                        return null;
                      }
                      rowSpan = targetObject.replLen;
                    }else if( key === "replId" ){
                      return <td style={{
                        textAlign:'center',
                      }}>{""+(replicateIndex+1)}</td>
                    }


                    let val;
                    if( key.includes('replicates.') ){

                      let repKey = key.split('.')[1];
                      val = listItemRep[repKey];
                    }else{
                      val = targetObject[key];
                    }





                    /*let border = {
                    border:((key!=="target" && val)?'3px solid red':'1px solid #ccc')
                  }*/


                    let itemIfSelected = {
                      figurePanelId:fpId,
                      key,
                      targetIndex,
                      replicateIndex,
                    }


                    let isSelected = JSON.stringify(itemIfSelected) === JSON.stringify(selectedItem);

                    let replicateObj = listItemRep;
                    let targetObj = targetObject;


                    let shouldIgnore = ignoreSelection?.(null,replicateObj)

                    return (
                      <td onClick={() => {
                        if( shouldIgnore ){ return; }
                        setSelectedItem(itemIfSelected)
                      }} class="rel side-border-on-hover column-highlight-hover" style={{
                        //borderLeft:'1px solid #ccc',
                        borderLeft:(key==="target" && '1px solid #ccc'),
                        borderRight:(key==="target" && '1px solid #ccc'),
                        textAlign:'center',
                        whiteSpace:'nowrap',

                        

                        cursor:(shouldIgnore?"default":"pointer"),


                      }} {...{rowSpan:(rowSpan>1&&rowSpan)}}>

                        <SupplementTableCell {...{ reportConfig, value:val, replicate:replicateObj, target: targetObj }}/>

                        {isSelected && <div class="selected-item-cover"/>}
                      </td>
                    )
                  })}
                </tr>
              ))}</tbody>))
          })}





        </table>

      </div>

      





      




    </div>
  )
}


